import { AutofillOptions } from '@modeso/types__aumico-lib-annualreport-be';

export const TAXONAMY = AutofillOptions.taxonamy;
export const NOTES = AutofillOptions.notes;
export const CFS = AutofillOptions.cashflow;
export const AOP = AutofillOptions.aop;
